import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { PublishedSites } from '../../helpers/schema';

export const schema = z.object({
  siteId: z.number(),
  action: z.enum(['enable', 'disable', 'reset']),
  customSchema: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  site: Selectable<PublishedSites>;
  databaseInfo?: {
    id: string;
    name: string;
  };
};

export const manageSiteDatabase = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/sites/database`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
